import { FeatureFlags, RequestError, SeasonalityEvents } from './enums';
import { WaitingList } from './interfaces';

export interface ResponseError<M = undefined> {
  error: {
    type: RequestError;
  };
  meta: M;
}

export type CreateSubscriptionErrorRes = ResponseError<{ queueLength: number }>;

export type WaitingListRes = WaitingList;

export enum FeatureCategory {
  PROTEIN = 'protein',
  TIME = 'time',
  LOYALTY = 'loyalty'
}

export type SubscriptionStatItem = {
  title: FeatureCategory;
  subtitle: string;
};

export type GetSubscriptionStatsRes = {
  stats: SubscriptionStatItem[];
};

export type GetFeatureFlagsResponse = {
  [key in SeasonalityEvents]?: {
    flags: {
      [key in FeatureFlags]?: boolean;
    };
    metaData: {
      start: string;
      end: string;
      isItBeforeRamadan?: boolean;
      isItDuringRamadan?: boolean;
      weeksUntilRamadan?: number;
      daysUntilRamadan?: number;
      isItPreEid?: boolean;
      quizDates?: {
        [FeatureFlags.FOUR_WEEKS_UNTIL_RAMADAN]?: string;
        [FeatureFlags.THREE_WEEKS_UNTIL_RAMADAN]?: string;
        [FeatureFlags.TWO_WEEKS_UNTIL_RAMADAN]?: string;
        [FeatureFlags.ONE_WEEK_UNTIL_RAMADAN]?: string;
      };
    };
  };
};

export interface ETA {
  time: string;
  createdAt: string;
}

export interface ETARange {
  range?: {
    gte: string; // iso string
    lte: string; // iso string
  };
}

export interface ETADataResponse extends ETARange {
  ETAs?: ETA[];
  time?: string;
}
